import { render, staticRenderFns } from "./AccordionToTab.vue?vue&type=template&id=7219a49a&scoped=true"
import script from "./AccordionToTab.js?vue&type=script&lang=js&external"
export * from "./AccordionToTab.js?vue&type=script&lang=js&external"
import style0 from "./AccordionToTab.scss?vue&type=style&index=0&id=7219a49a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7219a49a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default,HotIcon: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default,HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default,HotButton: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Button/Button.vue').default})
